import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy, AfterViewInit,
} from "@angular/core";
import { GlobalApp } from "../../../tools/global";
import { Router, ActivatedRoute } from "@angular/router";
import {PowerbiEmbedComponent} from "../../../elements/powerbi-embed/powerbi-embed.component";

@Component({
  selector: "powerbi-embedded",
  templateUrl: "./powerbi-embedded.component.html",
})
export class PowerBIEmbeddedComponent implements AfterViewInit {
  @ViewChild(PowerbiEmbedComponent) powerBi;
  interactId: string = null;
  interactType: string = null;
  actionType: string = null;
  filterId: string = null;
  bookmarkId: string = null;
  reportId: string = null;

  firstLoad: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private router: Router,
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      }
    });
  }

  ngAfterViewInit() {
    this.route.paramMap.subscribe((params) => {
      this.firstLoad = true;
      this.interactId = params.get("interactId");
      this.interactType = params.get("interactType");
      this.actionType = params.get("actionType");
      this.filterId = params.get("filterId");
      this.bookmarkId = params.get("bookmarkId");
      this.reportId = params.get("reportId");

      this.app.userState.subscribe((userState) => {
        if (this.firstLoad) {
          this.firstLoad = false;
          this.powerBi.loadInteractiveState(
            false,
            parseInt(this.app.getId()),
            this.interactId,
            this.interactType,
            this.actionType,
            this.filterId,
            this.bookmarkId,
            this.reportId,
            userState);
        }
      });
    });
  }
}
